import React, { useState, useEffect } from 'react';
import supabase from '../../../supabase-client';

const ImageDebugger = () => {
  const [books, setBooks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchBooks = async () => {
      try {
        const { data, error } = await supabase
          .from('productbook')
          .select('id_product, title_product, image_url_product')
          .order('id_product', { ascending: false })
          .limit(10);

        if (error) {
          console.error('Error fetching books:', error);
        } else {
          setBooks(data || []);
          console.log('📚 Books data:', data);
        }
      } catch (error) {
        console.error('Error:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchBooks();
  }, []);

  if (loading) return <div>Loading...</div>;

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h2 className="text-2xl font-bold mb-4">Image URL Debug</h2>
      <div className="space-y-4">
        {books.map(book => (
          <div key={book.id_product} className="border p-4 rounded">
            <h3 className="font-semibold">ID: {book.id_product}</h3>
            <p><strong>Title:</strong> {book.title_product}</p>
            <p><strong>Image URL:</strong> {book.image_url_product || 'NULL/EMPTY'}</p>
            {book.image_url_product && (
              <div className="mt-2">
                <p><strong>Image Preview:</strong></p>
                <img 
                  src={book.image_url_product} 
                  alt={book.title_product}
                  className="w-20 h-24 object-cover border"
                  onError={(e) => {
                    console.error('Image failed to load:', book.image_url_product);
                    e.target.style.display = 'none';
                  }}
                  onLoad={() => console.log('Image loaded successfully:', book.image_url_product)}
                />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ImageDebugger;

